//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'DpCircleLoader',
  props: {
    size: { type: String, default: '' },
    white: { type: Boolean, default: false },
    leftAligned: { type: Boolean, default: false },
  },
};
